import { useContext } from "react";
import { RemovalItemCostsDispatchContext } from "../SimulationProvider";

export const useRemovalItemCostsDispatch = () => {
  const dispatcher = useContext(RemovalItemCostsDispatchContext);
  if (!dispatcher) throw new Error("RemovalItemCostsDispatchContext not found");

  return dispatcher;
};
